import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import { doesUserNeedPrePayment, getLoggedUser, getUserOption, setNeedPrePayment } from '../../UserActions';
import { getOrdersByUser } from '../../../Order/OrderActions';

import withRouter from '../../../../components/Router/WithRouter';

function UserPrepaymentCheck({ dispatch, search, user = null, orders = [] }) {
	useEffect(() => {
		if(search.npp) { // npp for Need Pre Payment
			dispatch(setNeedPrePayment(search.npp !== 'remove'));
		}
	}, []);

	return process.env.NODE_ENV === 'development' && <Button onClick={() => dispatch(setNeedPrePayment(true))}>Enable prepayment</Button>;
}

UserPrepaymentCheck.propTypes = {
	dispatch: PropTypes.func.isRequired,
	search: PropTypes.object.isRequired,
	user: PropTypes.object,
	needPrePayment: PropTypes.bool,
	orders: PropTypes.arrayOf(PropTypes.object),
};

const mapStateToProps = (store, props) => {
	const user = getLoggedUser(store);
	return {
		user,
		needPrePayment: doesUserNeedPrePayment(store),
		orders: getOrdersByUser(store, user?._id, ['onpreparation', 'shipped', 'complete', 'archived']),
	};
};

export default connect(mapStateToProps)(withRouter(UserPrepaymentCheck));
